import { Box } from "@mui/material"
import type { ReactElement } from "react"

import DisplayAS400Id from "../common/DisplayAS400Id/DisplayAS400Id"

import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"
import type { WarehouseAreaOutputList } from "@/graphql/codegen/graphql"
import { WAREHOUSE_STATUS_MAP } from "@/screens/Warehouses/constants"
import { WarehouseStatus } from "@/screens/Warehouses/types"

interface WarehouseStatusCellProps {
  warehouse: WarehouseAreaOutputList
  "data-testid"?: string
}

export const WarehouseStatusCell = ({
  warehouse,
  "data-testid": testId = "warehouse-status",
}: WarehouseStatusCellProps): ReactElement => {
  return (
    <Box className='flex flex-col gap-1' data-testid={testId}>
      <Box className='flex items-center justify-start gap-2 px-1'>
        <StatusIndicator
          status={warehouse.isActive ? WarehouseStatus.Active : WarehouseStatus.Inactive}
          map={WAREHOUSE_STATUS_MAP}
        />
        <div data-testid='warehouse-public-id'>{warehouse.publicId}</div>
      </Box>
      <Box>
        <DisplayAS400Id id={warehouse.externalSystemId} data-testid='warehouse-external-id' />
      </Box>
    </Box>
  )
}
